// @ts-nocheck
import { useEffect, useMemo, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { transition } from '@crehana/ui';
import { scroll } from '@crehana/utils';

import { useTranslation } from '../hooks';
import routes from '../routes/config';

const SidebarMenu = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const mounted = useRef<boolean>(false);

  const currentIndex = useMemo(() => {
    if (location.pathname === '/' && window.innerWidth >= 768) {
      history.push(routes[0].path);
      return 0;
    }
    return routes.findIndex(r => location.pathname.includes(r.path));
  }, [location.pathname]);

  useEffect(() => {
    if (!mounted.current && location.pathname !== '/') {
      mounted.current = true;
    } else {
      scroll.scrollTop();
    }
  }, [location.pathname]);

  const onSelect = (value: string | number) => {
    history.push(routes[value as number].path);
  };

  return (
    <div
      className={`w-full ${
        location.pathname !== '/' ? 'hidden sm:flex' : 'flex'
      } flex-col`}
    >
      <h1 className="block font-h1 mb-24 sm:mb-40">Legal</h1>
      <span className="font-label text-base-lighter mb-8 sm:mb-12">
        {t('MENU_TITLE')}
      </span>
      {routes.map((route, i) => {
        const isSelected = currentIndex === i;
        const onClick = () => {
          onSelect(i);
        };

        return (
          <div key={`sidebar-button-${route.key}`} className="relative">
            <div
              className={`w-4 absolute left-0 top-0 mt-8 bg-primary-main ${
                isSelected ? 'opacity-1' : 'opacity-0'
              }`}
              style={{
                height: 'calc(100% - 16px)',
                transition: transition('opacity'),
              }}
            />
            <button
              type="button"
              className={`w-full flex items-center text-left py-20 sm:py-12 sm:px-20 font-link ${
                isSelected ? 'sm:text-primary-main' : 'sm:text-gray-dark-56'
              }${
                i < routes.length - 1
                  ? ' border-solid border-gray-light border-b sm:border-b-0'
                  : ''
              }`}
              onClick={onClick}
            >
              {t([`${route.key}_TITLE`])}
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default SidebarMenu;
